import { SVGProps } from 'react';
import { tokens } from '../../core/theme';

type WarningIconProps = SVGProps<SVGSVGElement> & { color?: string };

export const WarningIcon = ({
  width = 24,
  height = 24,
  color = tokens.colors.brand.red.DEFAULT,
  ...props
}: WarningIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.6103 3.7089C11.2103 2.6089 12.7897 2.6089 13.3897 3.7089L20.6103 17.2911C21.1732 18.3221 20.4173 19.5 19.2308 19.5H4.76916C3.58265 19.5 2.82676 18.3221 3.38969 17.2911L10.6103 3.7089Z"
        stroke={color}
        strokeWidth={1.59167}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9.5V13.5"
        stroke={color}
        strokeWidth={1.59167}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.749 16C11.611 16 11.499 16.112 11.5 16.25C11.5 16.388 11.612 16.5 11.75 16.5C11.888 16.5 12 16.388 12 16.25C12 16.112 11.888 16 11.749 16"
        stroke={color}
        strokeWidth={1.59167}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
